import { AccordionItem } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Accordion';
import { OpenLink } from '@johnlewispartnership/wtr-ingredients/dist/foundations/icons';
import PropTypes from 'prop-types';
import React from 'react';
import EventMonitor from 'components/EventMonitor/EventMonitor';
import styles from './index.scss';

const UTMLinkTitles = ['Cellar', 'Florist', 'Gifts'];

const getHrefWithUTMParameter = link => {
  if (!UTMLinkTitles.includes(link.title)) {
    return link.href;
  }

  const [linkBase, params] = link.href.split('?');

  const searchParams = new URLSearchParams(params);

  const utmCampaign = searchParams.get('utm_campaign');

  if (!utmCampaign) {
    searchParams.set('utm_campaign', 'footer_link');
    searchParams.set('utm_content', link.title.toLowerCase());
    searchParams.set('utm_source', 'waitrose.com');
    searchParams.set('utm_medium', 'referral');
  }

  return `${linkBase}?${searchParams.toString()}`;
};

const FooterLinkList = ({ accordion, classesToAdd, section: { links, title } }) => {
  const accordionProps = {
    title,
    id: title.toLowerCase(),
  };

  const linksComponent = links
    ? links.map((link, index) => {
        const eventProps = {
          actionType: 'redirect',
          originComponent: 'footer link',
          shortDescription: `footer link: ${title}: ${link.title}`,
          key: `footer-${title.replace(/\s+/g, '-').toLowerCase()}-${index}`,
          classNames: [styles.footerLinkGroup],
        };
        const linkProps = {
          className: styles.footerLink,
          href: getHrefWithUTMParameter(link),
          target: link.popup ? '_blank' : '_self',
        };

        return (
          <EventMonitor {...eventProps}>
            <a {...linkProps}>
              <span>{link.title}</span>
              {link.popup && (
                <OpenLink className={styles.openlink} size="xsmall" title="Opens in new window" />
              )}
            </a>
          </EventMonitor>
        );
      })
    : null;

  return accordion ? (
    <AccordionItem {...accordionProps}>{linksComponent}</AccordionItem>
  ) : (
    <div className={classesToAdd ? `${styles.linkSection} ${classesToAdd}` : styles.linkSection}>
      <h3 className={styles.linkSectionTitle}>{title}</h3>
      {linksComponent}
    </div>
  );
};

FooterLinkList.propTypes = {
  accordion: PropTypes.bool,
  classesToAdd: PropTypes.string,
  section: PropTypes.object.isRequired,
};

FooterLinkList.defaultProps = {
  accordion: false,
  classesToAdd: '',
};

FooterLinkList.displayName = 'FooterLinkList';

export default FooterLinkList;
